import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SystemHealthCheckPathParameters } from 'api/actions/system-health-check/system-health-check-path-parameters';
import { SystemHealthCheckResponse } from 'api/actions/system-health-check/system-health-check-response';

type SystemHealthCheckQueryParameters = Record<string, any>;

/**
 * The path of the SystemHealthCheck action.
 */
export const systemHealthCheckActionPath = new SweetPath<keyof SystemHealthCheckPathParameters>(
  '/api/system/health-check',
  { path: '{param}' }
);

/**
 * Creates a contextualized SystemHealthCheck actions.
 */
export default function createSystemHealthCheckAction(axios: AxiosInstance) {
  return function systemHealthCheckAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: SystemHealthCheckQueryParameters } = {}) {
    const path = systemHealthCheckActionPath.original;

    return axios.request<SystemHealthCheckResponse, SystemHealthCheckResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
